<cipo-dialog-header
    [title]="data.title"
    [fullScreen]="data.enableFullscreen ? 'always' : 'default'"
    [hideCloseWhenDisabled]="true" />
<mat-dialog-content>
    <div class="p-t" data-testid="cipo-info-dialog-content">
        @if (data.description) {
            @if (data.isFroala) {
                <app-froala [editmode]="false" [content]="data.description" />
            } @else {
                <p>{{ data.description | translate }}</p>
            }
        }
        @for (message of data.messages; track trackBy($index, message)) {
            <p>{{ message | translate }}</p>
        }
    </div>
</mat-dialog-content>
